<template>
  <div class="service-display">
    <!-- 门店选择器 -->
    <div class="store-selector-wrapper">
      <div class="selector-label">选择门店：</div>
      <el-select
        v-model="selectedStoreId"
        placeholder="请输入门店名称搜索"
        class="store-selector"
        @change="handleStoreChange"
        @clear="handleSelectClear"
        :loading="storeListLoading"
        filterable
        remote
        :remote-method="searchStores"
        @visible-change="handleSelectVisibleChange"
        @focus="handleSelectFocus"
        @blur="handleSelectBlur"
        popper-class="store-select-popper"
        clearable
        :no-data-text="searchKeyword ? '未找到相关门店' : '请输入门店名称搜索'"
      >
        <el-option v-for="store in storeList" :key="store.id" :label="store.name" :value="store.id">
          <span class="store-option">
            <span class="store-name">{{ store.name }}</span>
          </span>
        </el-option>

        <!-- 加载更多选项 -->
        <el-option
          v-if="hasMoreStores && !storeListLoading && storeList.length > 0"
          key="load-more"
          value="__LOAD_MORE__"
          disabled
          class="load-more-option"
        >
          <div class="load-more-text" @click.stop="loadMoreStores">
            <i class="el-icon-more"></i>
            加载更多门店...
          </div>
        </el-option>

        <!-- 分页加载中 -->
        <el-option
          v-if="storeListLoading && storeList.length > 0"
          key="loading"
          value="__LOADING__"
          disabled
          class="loading-option"
        >
          <div class="loading-text">
            <i class="el-icon-loading"></i>
            加载中...
          </div>
        </el-option>

        <!-- 搜索结果为空时的提示 -->
        <el-option
          v-if="!storeListLoading && storeList.length === 0 && searchKeyword"
          key="no-result"
          value="__NO_RESULT__"
          disabled
          class="no-result-option"
        >
          <div class="no-result-text">
            <i class="el-icon-search"></i>
            未找到 "{{ searchKeyword }}" 相关的门店
          </div>
        </el-option>
      </el-select>
    </div>

    <!-- 第一个模块：点数余额 -->
    <div class="module-wrapper">
      <div class="module-title">点数余额</div>
      <div class="serviceLeftMoney" v-loading="accountInfoLoading" element-loading-text="加载中...">
        <template v-if="!accountInfoLoading">
          <div class="base_header_title">点数余额</div>
          <div :class="['service-left-money_main', serviceLeftMoneyClassName]">
            <span>{{ storeAccoutnInfo.availableAmount || 0 }}</span>
            <b>点</b>
          </div>
          <div class="serviceLeftMoneyBottom">
            <div class="allMoney">
              <div class="allMoneyTittle">
                累计购买金额
                <div class="question_mark">
                  <el-tooltip class="item" effect="dark" content="历史累计购买金额" placement="right">
                    <img :src="require('@/assets/img/account/icon_question_mark.png')" alt="" />
                  </el-tooltip>
                </div>
              </div>
              <div class="allMoneyNum">
                {{ storeAccoutnInfo.totalRechargeAmount / 100 || 0 }}
                <span>元</span>
              </div>
            </div>
            <div class="allUse">
              <div class="allUseTittle">
                累计消费点数
                <div class="question_mark">
                  <el-tooltip class="item" effect="dark" content="合同周期内的累计消费点数" placement="right">
                    <img :src="require('@/assets/img/account/icon_question_mark.png')" alt="" />
                  </el-tooltip>
                </div>
              </div>
              <div class="allUseNum">
                {{ storeAccoutnInfo.totalConsumeCoin || 0 }}
                <span>点</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 第二个模块：门店套餐明细 -->
    <div class="module-wrapper">
      <div class="module-header">
        <div class="module-title">门店套餐明细</div>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          class="export-btn"
          @click="exportAllPackageDetails"
        >
          导出全部
        </el-button>
      </div>
      <!-- 数据说明 -->
      <div class="data-explanation">
        <div class="explanation-section">
          <div class="section-title">数据范围：</div>
          <div class="section-content">本列表展示有效期内、待生效的套餐（不包含已过期的套餐）</div>
        </div>

        <div class="explanation-section">
          <div class="section-title">数据标签：</div>
          <div class="section-content">
            <div class="label-item">
              <span class="label-number">1.</span>
              <span class="label-name">即将到期：</span>
              <span class="label-desc">套餐有效期不足30天</span>
            </div>
            <div class="label-item">
              <span class="label-number">2.</span>
              <span class="label-name">余量紧张：</span>
              <span class="label-desc">①图文余量或视频余量不足30天 或②店均可用余额预估可用天数不足30天</span>
            </div>
          </div>
        </div>

        <div class="explanation-note">
          <strong>注：</strong>
          数据实时更新，「即将到期」「余量紧张」的标签除外（标签数据T+1更新）
        </div>
      </div>

      <!-- 套餐明细表格 -->
      <div class="module-content" v-loading="packageDetailLoading" element-loading-text="加载中...">
        <div class="package-table-wrapper">
          <el-table
            :data="packageDetailList"
            header-row-class-name="common-table-header"
            row-class-name="common-table-row"
            class="common-table package-detail-table"
            border
            stripe
          >
            <el-table-column prop="storeName" label="药店名称" min-width="120">
              <template slot-scope="scope">
                <div class="text-wrap">
                  {{ scope.row.storeName || '-' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="packageType" label="套餐类型" width="100">
              <template slot-scope="scope">
                <div class="text-wrap">
                  {{ scope.row.packageType || '-' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="packageName" label="套餐名称" min-width="150">
              <template slot-scope="scope">
                <div class="package-name-wrapper">
                  <div class="package-name text-wrap">{{ scope.row.packageName || '-' }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="hospitalName" label="签约网院" min-width="120">
              <template slot-scope="scope">
                <div class="text-wrap">
                  {{ scope.row.hospitalName || '-' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="feeModel" label="收费模式" width="100">
              <template slot-scope="scope">
                <div class="text-wrap">
                  {{ scope.row.feeModel || '-' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="contractId" label="合同编号" min-width="140">
              <template slot-scope="scope">
                <div class="text-wrap">
                  <span class="contract-number">{{ scope.row.contractId || '-' }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="packageValidPeriod" label="套餐有效期" min-width="120">
              <template slot-scope="scope">
                <div class="text-wrap">
                  <span>
                    {{ scope.row.packageValidPeriod || '-' }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="balance" label="余额（元）" width="100" align="right">
              <template slot-scope="scope">
                <span class="balance-amount">{{ scope.row.balance || '-' }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="textImageRemaining" label="图文余量（张）" width="200" align="right">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.textImageRemaining || '-' }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="videoRemaining" label="视频余量（张）" width="200" align="right">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.videoRemaining || '-' }}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="aboutToExpire" label="即将到期" width="120" align="center">
              <template slot-scope="scope">
                <div class="status-indicators">
                  <span>
                    {{ scope.row.aboutToExpire || '-' }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remainingTight" label="余量紧张" width="120" align="center">
              <template slot-scope="scope">
                <div class="status-indicators">
                  <span>
                    {{ scope.row.remainingTight || '-' }}
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SERVER_STATUS, serverStatusOption } from '@/lib/constant';
import { baseFormat } from '@fastweb/f2e-utils';
import { mapGetters } from 'vuex';
import { getStorePage, getStorePackageDetail, storeCoinDetail } from '@/api';

import { constOptions } from '@/util';

export default {
  data() {
    return {
      // 门店账户类型
      storeAccountType: {
        1: '年费会员',
        2: '储值会员',
        3: '试用会员',
        4: '普通会员'
      },
      serverStatusOption,
      storeAccoutnInfo: {},
      selectedStoreId: '', // 选中的门店ID
      storeList: [], // 门店列表
      // 分页相关
      currentPageNo: 1, // 当前页码
      pageSize: 20, // 每页数量
      hasMoreStores: true, // 是否还有更多门店
      totalStores: 0, // 门店总数
      searchKeyword: '', // 搜索关键词
      searchTimer: null, // 搜索防抖定时器
      // 套餐明细相关
      packageDetailList: [], // 套餐明细列表
      // 加载状态
      storeListLoading: false, // 门店列表加载状态
      accountInfoLoading: false, // 账户信息加载状态
      packageDetailLoading: false, // 套餐明细加载状态
      // 请求序号：避免旧请求返回后覆盖当前门店或当前搜索结果
      storeListRequestId: 0,
      storeDataRequestId: 0,
      // 搜索结果在下次展开时再恢复为完整门店列表，避免刚选中时发起竞争请求
      needResetStoreList: false
    };
  },
  computed: {
    serviceModeClassName() {
      const { storeType = 0, isExpire } = this.storeAccoutnInfo;
      // 合同到期
      if (isExpire) return 'expire';
      const classNameObj = {
        1: 'annual-fee', // 年费
        2: 'stored-value', // 储值
        3: 'trial', // 试用
        4: 'normal' // 普通
      };
      return classNameObj[storeType] || '';
    },
    serviceModeIcon() {
      const { storeType, isExpire } = this.storeAccoutnInfo;
      // 合同到期
      if (isExpire) return 'expire';
      return `type_${storeType}`;
    },
    serviceLeftMoneyClassName() {
      // 渲染点数余额不同样式
      const { storeAccoutnInfo = {} } = this;
      const { availableAmount } = storeAccoutnInfo;
      if (availableAmount > 10) return 'orange';
      if (availableAmount < 10) return 'red';
      return '';
    },
    expireWarningShow() {
      const { storeAccoutnInfo } = this;
      if (!storeAccoutnInfo) return false;
      return storeAccoutnInfo.isExpire;
    }
  },
  methods: {
    async exportAllPackageDetails() {
      this.$store.dispatch('download/exportFile', {
        exportType: 'exportPackageDetail'
      });
    },
    goPage(type) {
      const jumpObj = {
        1: 'addAccountHistory',
        2: 'useAccountHistory'
      };
      this.$router.push(`shopAccount/${jumpObj[type]}`);
    },

    /**
     * 处理门店选择变化
     */
    async handleStoreChange(storeId) {
      const requestId = ++this.storeDataRequestId;
      console.log('选中门店ID:', storeId);
      if (!storeId) {
        return;
      }

      const selectedStore = this.storeList.find(store => store.id === storeId);
      console.log('选中门店信息:', selectedStore);

      // 触发父组件事件，传递选中的门店信息
      this.$emit('store-change', {
        storeId,
        storeInfo: selectedStore
      });

      // 同时加载账户信息和套餐明细
      await Promise.all([this.fetchStoreAccountInfo(storeId, requestId), this.loadPackageDetail(storeId, requestId)]);
    },

    /**
     * 获取指定门店的账户信息
     */
    async fetchStoreAccountInfo(storeId, requestId) {
      try {
        this.accountInfoLoading = true;
        console.log('获取门店账户信息，storeId:', storeId);
        // 这里可以调用特定门店的账户信息API
        // 如果API支持传递storeId参数
        const res = await storeCoinDetail({ storeId });

        if (requestId !== this.storeDataRequestId || storeId !== this.selectedStoreId) {
          return;
        }

        this.storeAccoutnInfo = res;
        console.log('res', res);
        console.log('账户信息加载完成');
      } catch (error) {
        if (requestId === this.storeDataRequestId && storeId === this.selectedStoreId) {
          console.error('获取门店账户信息失败:', error);
        }
      } finally {
        if (requestId === this.storeDataRequestId && storeId === this.selectedStoreId) {
          this.accountInfoLoading = false;
        }
      }
    },

    /**
     * 加载套餐明细
     */
    async loadPackageDetail(storeId, requestId) {
      try {
        this.packageDetailLoading = true;
        console.log('加载门店套餐明细:', storeId);

        if (!storeId) {
          this.packageDetailList = [];
          return;
        }

        const params = {
          storeId
        };

        const res = await getStorePackageDetail(params);
        console.log('套餐明细加载结果:', res);
        const { data = [] } = res;

        if (requestId !== this.storeDataRequestId || storeId !== this.selectedStoreId) {
          return;
        }

        console.log('套餐明细加载完成:', data);
        this.packageDetailList = data;
      } catch (error) {
        if (requestId === this.storeDataRequestId && storeId === this.selectedStoreId) {
          console.error('加载套餐明细失败:', error);
          this.$message.error('加载套餐明细失败');
          this.packageDetailList = [];
        }
      } finally {
        if (requestId === this.storeDataRequestId && storeId === this.selectedStoreId) {
          this.packageDetailLoading = false;
        }
      }
    },

    /**
     * 处理选择器显示/隐藏
     */
    handleSelectVisibleChange(visible) {
      // 移除这里的逻辑，因为我们在 mounted 中已经加载了
    },

    /**
     * 搜索门店
     */
    async searchStores(keyword) {
      console.log('搜索门店:', keyword);
      const searchKeyword = keyword || '';

      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 输入变化时立即使已发出的旧列表请求失效
      this.storeListRequestId++;
      this.needResetStoreList = false;

      // 防抖处理，避免频繁请求
      this.searchTimer = setTimeout(async () => {
        this.searchTimer = null;
        this.searchKeyword = searchKeyword;
        this.currentPageNo = 1;
        this.storeList = [];
        this.hasMoreStores = true;
        // 仅全量列表默认选中第一家，搜索结果由用户主动选择
        await this.loadStoreList(true, !searchKeyword.trim());
      }, 300);
    },

    /**
     * 加载更多门店
     */
    async loadMoreStores() {
      console.log('点击加载更多门店...');
      if (this.storeListLoading || !this.hasMoreStores) {
        console.log('无法加载更多:', { loading: this.storeListLoading, hasMore: this.hasMoreStores });
        return;
      }

      this.currentPageNo++;
      console.log('加载下一页:', this.currentPageNo);
      await this.loadStoreList(false);
    },

    /**
     * 加载门店列表
     * @param {boolean} isFirstLoad 是否是首次加载
     * @param {boolean} autoSelectFirst 是否自动选中第一页第一家门店
     */
    async loadStoreList(isFirstLoad = true, autoSelectFirst = false) {
      const requestId = ++this.storeListRequestId;
      const pageNo = this.currentPageNo;
      const keyword = this.searchKeyword;

      try {
        this.storeListLoading = true;
        console.log(`加载门店列表 - 页码: ${pageNo}, 关键词: "${keyword}"`);

        const params = {
          pageNo,
          pageSize: this.pageSize
        };

        // 如果有搜索关键词，添加storeName参数
        if (keyword && keyword.trim()) {
          params.storeName = keyword.trim();
        }

        const res = await getStorePage(params);

        if (requestId !== this.storeListRequestId) {
          return;
        }

        const { data = [], total = 0 } = res;

        console.log(`门店列表加载结果 - 当前页数据:`, data);
        console.log(`总数: ${total}, 当前页: ${pageNo}, 搜索词: "${keyword}"`);

        if (isFirstLoad) {
          this.storeList = data;
        } else {
          // 追加到现有列表
          this.storeList = [...this.storeList, ...data];
        }

        this.totalStores = total;

        // 判断是否还有更多数据
        this.hasMoreStores = res.hasNextPage;

        // 如果是首次加载且有数据，自动选择第一个门店
        if (isFirstLoad && autoSelectFirst && data.length > 0 && !this.selectedStoreId) {
          this.selectedStoreId = data[0].id;
          console.log('自动选择第一个门店:', data[0]);
          this.handleStoreChange(this.selectedStoreId);
        }
      } catch (error) {
        if (requestId === this.storeListRequestId) {
          console.error('加载门店列表失败:', error);
          this.$message.error('加载门店列表失败');
        }
      } finally {
        if (requestId === this.storeListRequestId) {
          this.storeListLoading = false;
        }
      }
    },

    /**
     * 初始化门店列表 - 加载第一页
     */
    async initStoreList() {
      console.log('初始化门店列表，加载第一页数据...');
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }

      // 初始化动作开始时就使旧列表请求失效，避免旧搜索结果覆盖默认列表
      this.storeListRequestId++;
      this.currentPageNo = 1;
      this.searchKeyword = '';
      this.storeList = [];
      this.hasMoreStores = true;
      await this.loadStoreList(true, true);
    },

    /**
     * 处理选择器获得焦点
     */
    handleSelectFocus() {
      // 搜索结果只保留到本次选择结束；下次展开时再恢复完整列表
      if (this.storeList.length === 0 || this.needResetStoreList) {
        this.needResetStoreList = false;
        this.initStoreList();
      }
    },

    /**
     * 处理选择器失去焦点
     */
    handleSelectBlur() {
      // 清空搜索关键词，下次打开时显示完整列表
      if (this.searchKeyword) {
        this.searchKeyword = '';
        this.needResetStoreList = true;
      }
    },

    /**
     * 处理选择器清空事件（点击×按钮）
     */
    async handleSelectClear() {
      console.log('清空选择器，重新加载门店列表');

      // 旧门店的余额、套餐请求即使晚返回，也不允许覆盖清空后的默认门店
      this.storeDataRequestId++;

      // 清空搜索关键词
      this.searchKeyword = '';
      this.needResetStoreList = false;

      // 清空选中的门店ID
      this.selectedStoreId = '';
      this.packageDetailList = [];
      this.storeAccoutnInfo = {};
      this.accountInfoLoading = false;
      this.packageDetailLoading = false;
      // 重新加载完整的门店列表
      await this.initStoreList();
    }
  },

  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },

  filters: {
    baseFormat
  },

  async mounted() {
    // 页面加载时立即加载第一页门店数据
    console.log('组件挂载，开始加载第一页门店数据...');
    await this.initStoreList();
  }
};
</script>

<style lang="scss" scoped>
.service-display {
  .right_icon {
    width: 5px;
    height: 8px;
    margin-top: -3px;
  }
  .question_mark {
    width: 12px;
    cursor: pointer;
    margin-right: 4px;
    margin-left: 2px;
    img {
      width: 12px;
      margin-top: 2px;
    }
  }
  .baseHeader {
    padding: 16px;
    margin-bottom: 16px;
    height: 145px;
    overflow-y: auto;
    flex: 1;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
    border-radius: 4px;
    border: 1px solid rgba(242, 242, 242, 1);
    position: relative; // 为 loading 定位
  }

  // 门店选择器样式
  .store-selector-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;

    .selector-label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-right: 12px;
      white-space: nowrap;
    }

    .store-selector {
      width: 300px;

      ::v-deep .el-select__wrapper {
        border-radius: 6px;
      }

      // 搜索状态下的样式
      ::v-deep .el-input__inner {
        &::placeholder {
          color: #999;
          font-size: 13px;
        }
      }
    }
  }

  // 模块容器样式
  .module-wrapper {
    margin-bottom: 24px;

    .module-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .module-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin: 0;
        margin-right: 20px;
      }

      .export-btn {
        font-size: 12px;
        padding: 6px 12px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(64, 169, 255, 0.3);
        }

        &:active {
          transform: translateY(0);
        }

        .el-icon-download {
          margin-right: 4px;
        }
      }
    }

    .module-content {
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      border: 1px solid #e9ecef;
      min-height: 200px;
      padding: 24px;
      position: relative; // 为 loading 定位

      .placeholder-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 150px;
        color: #999;
        font-size: 14px;
        background: #fafafa;
        border-radius: 6px;
        border: 2px dashed #d9d9d9;

        p {
          margin: 8px 0;
        }
      }
    }
  }

  .serviceLeftMoney {
    @extend .baseHeader;
    width: 400px;

    .service-left-money_main {
      margin-top: 12px;
      width: 100%;
      text-align: center;
      top: 47px;
      span {
        font-weight: bold;
        font-size: 22px;
        margin-right: 12px;
      }
      b {
        font-size: 14px;
        color: #bdbdbd;
      }
    }
    .green {
      span {
        color: #1e8dff;
      }
    }
    .orange {
      span {
        color: #ebb436;
      }
    }
    .red {
      span {
        color: #e0514c;
      }
    }
    .serviceLeftMoneyBottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .allMoney {
        cursor: pointer;
        .allMoneyTittle {
          display: flex;
          font-size: 12px;
          color: #707070;
          align-items: center;
          &:hover {
            text-decoration: underline;
          }
        }
        .allMoneyNum {
          padding-top: 1px;
          font-size: 14px;
          color: #707070;
          font-weight: bold;
          span {
            font-size: 12px;
            color: #707070;
          }
        }
      }
      .allUse {
        cursor: pointer;
        .allUseTittle {
          display: flex;
          font-size: 12px;
          color: #707070;
          align-items: center;
          &:hover {
            text-decoration: underline;
          }
        }
        .allUseNum {
          padding-top: 1px;
          font-size: 14px;
          color: #707070;
          font-weight: bold;
          span {
            font-size: 12px;
            color: #707070;
          }
        }
      }
    }
  }
  .base_header_title {
    font-weight: bold;
    color: rgba(36, 36, 36, 1);
    font-size: 14px;
    .contract-tip {
      display: inline-block;
      margin-left: 4px;
      padding: 4px;
      background: #ebf8ff;
      font-size: 12px;
      color: #1e8dff;
      border-radius: 2px;
    }
  }

  // 门店选项样式
  ::v-deep .store-option {
    display: flex;
    flex-direction: column;

    .store-name {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .store-address {
      font-size: 12px;
      color: #999;
      margin-top: 2px;
    }
  }

  // 数据说明样式
  .data-explanation {
    margin: 16px 0;
    padding: 20px;
    background: #f0f8ff;
    border-radius: 8px;
    border-left: 4px solid #1890ff;
    font-size: 14px;
    line-height: 1.6;

    .explanation-section {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 8px;
      }

      .section-content {
        color: #333;
        margin-left: 8px;
      }
    }

    .label-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }

      .label-number {
        font-size: 14px;
        color: #1890ff;
        font-weight: 600;
        margin-right: 6px;
        flex-shrink: 0;
      }

      .label-name {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        margin-right: 6px;
        flex-shrink: 0;
      }

      .label-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
        flex: 1;
      }
    }

    .explanation-note {
      margin-top: 16px;
      padding-top: 12px;
      border-top: 1px solid #d9d9d9;
      font-size: 13px;
      color: #666;
      line-height: 1.6;

      strong {
        color: #fa541c;
        font-weight: 600;
      }
    }
  }

  // 套餐明细表格样式
  .package-table-wrapper {
    .package-detail-table {
      margin-top: 16px;

      // 统一的表格单元格文本样式
      .text-wrap,
      .package-name,
      .contract-number,
      .balance-amount,
      span {
        font-size: 14px !important;
        color: #333 !important;
        font-weight: normal !important;
        word-wrap: break-word;
        word-break: break-all;
        white-space: normal;
        line-height: 1.4;
        min-height: 20px;
      }

      .package-name-wrapper {
        .package-name {
          // 移除之前的特殊样式，使用统一样式
          margin-bottom: 4px;
        }

        .package-tags {
          margin-top: 4px;

          .package-tag {
            margin-right: 4px;
            margin-bottom: 2px;
          }
        }
      }

      .contract-number {
        font-size: 12px;
        color: #999;
        margin-left: 8px;
      }

      .balance-amount {
        font-size: 14px;
        color: #707070;
        font-weight: bold;
      }

      .status-indicators {
        display: flex;
        align-items: center;
        gap: 4px;

        .status-tag {
          font-size: 14px !important;
          color: #333 !important;
          font-weight: normal !important;
        }
      }

      // 保留状态相关的颜色样式（如过期状态）
      .expired {
        color: #f56c6c !important;
      }

      .about-to-expire {
        color: #e6a23c !important;
      }

      .normal {
        color: #67c23a !important;
      }

      // 也可以尝试这个选择器
    }
  }

  // 选择器下拉面板样式
  ::v-deep .store-select-popper {
    .load-more-option,
    .loading-option,
    .no-result-option {
      .el-select-dropdown__item {
        height: auto !important;
        padding: 8px 20px !important;
        line-height: normal !important;

        &:hover {
          background-color: #f5f7fa !important;
        }
      }
    }

    .load-more-text {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1890ff;
      cursor: pointer;
      font-size: 13px;
      padding: 4px 0;

      i {
        margin-right: 6px;
      }

      &:hover {
        color: #40a9ff;
      }
    }

    .loading-text {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 13px;
      padding: 4px 0;

      i {
        margin-right: 6px;
      }
    }

    .no-result-text {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #999;
      font-size: 13px;
      padding: 8px 0;
      text-align: center;

      i {
        margin-bottom: 4px;
        font-size: 16px;
      }

      .el-button {
        margin-top: 4px;
        padding: 0;
      }
    }
  }
}
</style>
